import * as React from 'react';

import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { getCustomComponent } from 'components/Themes';
import { ProductDetailsViewProps } from 'lib/themes/themes';

export const ProductDetailsView = (props: ProductDetailsViewProps) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  const CustomComponent = getCustomComponent(bookingWidgetTheme, 'ProductDetailsView');
  return <CustomComponent {...props} />;
};
